import { useEffect, useState } from 'react'

/**
 * The terminal's clock as React state, ticking every `everyMs`. For displays that compare an
 * API timestamp against "now" — an overdue arrival estimate on the delivery board — so the
 * figure keeps counting between polls instead of freezing at the last render.
 */
export const useNow = (everyMs: number): number => {
  const [now, setNow] = useState(() => Date.now())
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), everyMs)
    return () => clearInterval(id)
  }, [everyMs])
  return now
}
